import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../DataTable';
import Spinner from "../Spinner";

@inject("dataOriginParameterTemplateStore")
@observer
class DataOriginParameterList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { dataOriginParameterTemplateStore } = this.props;
    dataOriginParameterTemplateStore.fetchItems();
  }

  handleDelete(idOrIds) {
    console.log('handleDelete', idOrIds);
    this.props.dataOriginParameterTemplateStore.removeItems(idOrIds);
  }

  slug = 'daq/parameter-template';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
  ];

  render() {
    const { dataOriginParameterTemplateStore } = this.props;
    // const { route: { dataOriginParameterTemplateStore }, children } = this.props;
    const { children } = this.props;

    return (
      <div>
        <DataTable
          data={dataOriginParameterTemplateStore.items}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
        />
        {dataOriginParameterTemplateStore.isLoading && <Spinner/>}
        {children}
      </div>
    );
  }
}

export default DataOriginParameterList;



// WEBPACK FOOTER //
// ./src/components/DataSource/DataOriginParameterList.js